import { Component } from '@angular/core';

@Component({
  selector: 'app-onboarding-background-flair',
  standalone: false,
  templateUrl: './onboarding-background-flair.component.html',
})
export class OnboardingBackgroundFlairComponent {}
